import { Select as SelectPrimitive } from "@base-ui/react/select"
import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

const SelectItem = ({ className, children, ...props }) => (
  <SelectPrimitive.Item
    data-slot="select-item"
    className={classNames(
      "flex cursor-pointer items-center px-2 py-1.5 text-sm",
      "text-gray-800",
      "group data-[highlighted]:rounded data-[highlighted]:bg-blue-800 data-[highlighted]:text-white",
      "data-[disabled]:cursor-not-allowed data-[disabled]:text-gray-400",
      className
    )}
    {...props}
  >
    <span className="mr-1.5 flex h-3.5 w-3.5 items-center justify-center">
      <SelectPrimitive.ItemIndicator>
        <i className="fa-kit fa-check text-xs" />
      </SelectPrimitive.ItemIndicator>
    </span>
    <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
  </SelectPrimitive.Item>
)

SelectItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  disabled: PropTypes.bool,
}

export default SelectItem
